var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"page call-in col"},[_c('div',{staticClass:"acc-center-body"},[_c('div',{staticClass:"center-info"},[_c('div',{staticClass:"border-bottom row"},[_c('div',{staticClass:"col-span border-right"},[_c('relation-query',{ref:"relation-query-base"})],1)])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }